import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViceCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Element Icon vice captain" }),
		/* @__PURE__ */ _jsx("g", {
			id: "icon_circle",
			"data-name": "icon circle",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 16
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "symbol_vice",
			"data-name": "symbol vice",
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("path", { d: "M25,8.5l-6.1,16H13.2L7,8.5h4.2L16,21.4,20.8,8.5H25Z" })
		})
	]
});
export default SvgViceCaptain;
